var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "myprops-root", style: _vm.cssVars() }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `paddingTop:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow09.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "tit-left" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k392"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _c("div", { staticClass: "myprops-tab" }, [
          _c(
            "div",
            {
              class: { "tab-on": _vm.tabIndex === 1 },
              on: {
                click: function ($event) {
                  return _vm.handleTab(1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.commonM.k393")))]
          ),
          _c(
            "div",
            {
              class: { "tab-on": _vm.tabIndex === 2 },
              on: {
                click: function ($event) {
                  return _vm.handleTab(2)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.giftSign.coupon")))]
          ),
          _c(
            "div",
            {
              class: { "tab-on": _vm.tabIndex === 3 },
              on: {
                click: function ($event) {
                  return _vm.handleTab(3)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.commonM.k394")))]
          ),
        ]),
      ],
      1
    ),
    _vm.tabIndex === 1
      ? _c("div", { staticClass: "myprops-content pass" }, [
          _c(
            "div",
            { staticClass: "banner-swipe" },
            [
              _c(
                "swiper",
                {
                  staticClass: "swiper-root",
                  attrs: { options: _vm.swiperOptions },
                },
                _vm._l(_vm.serviceAdvantageData, function (item) {
                  return _c("swiper-slide", { key: item.id }, [
                    _c(
                      "div",
                      {
                        staticClass: "slide-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleBannerClick(item)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm._f("imgPath")(item.content) },
                        }),
                      ]
                    ),
                  ])
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "prop-block" },
            [
              _vm._l(_vm.passList, function (item) {
                return _c(
                  "div",
                  {
                    staticClass: "prop-item",
                    on: {
                      click: function ($event) {
                        return _vm.handlePassUse(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "item-top" }, [
                      item.remainTimeSeconds > 0
                        ? _c(
                            "div",
                            { staticClass: "item-top-left" },
                            [
                              item.timeType === "forever"
                                ? [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("lang.commonM.k395"))
                                    ),
                                  ]
                                : _vm._e(),
                              item.timeType === "days"
                                ? [
                                    _c("div", { staticClass: "time-icon" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.transformSeconds2(
                                            item.remainTimeSeconds
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                : _vm._e(),
                              item.timeType === "hours"
                                ? [
                                    item.countDown &&
                                    item.countDown.countdownResult
                                      ? [
                                          _c("div", {
                                            staticClass: "time-icon",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.countDown.countdownResult
                                                  .hours
                                              ) +
                                              ":" +
                                              _vm._s(
                                                item.countDown.countdownResult
                                                  .minutes
                                              ) +
                                              ":" +
                                              _vm._s(
                                                item.countDown.countdownResult
                                                  .seconds
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _c("div", { staticClass: "item-top-left" }),
                      _c("div", {
                        staticClass: "detail-icon",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handlePassTips(item)
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "pass-icon" }, [
                      item.propType == 15
                        ? _c("img", {
                            attrs: { src: _vm.getMatchImg("super-chat-pass") },
                          })
                        : _vm._e(),
                      item.propType == 1
                        ? _c("img", {
                            attrs: { src: _vm.getMatchImg("super-chat-pass") },
                          })
                        : _vm._e(),
                      item.propType == 2
                        ? _c("img", {
                            attrs: { src: _vm.getMatchImg("video-pass") },
                          })
                        : _vm._e(),
                      item.propType == 6
                        ? _c("img", {
                            attrs: { src: _vm.getMatchImg("call-pass") },
                          })
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "pass-name" }, [
                      _vm._v(_vm._s(_vm.passTypeTxt[item.propType])),
                    ]),
                    _c("div", { staticClass: "count" }, [
                      _vm._v("x" + _vm._s(item.number)),
                    ]),
                    _c("div", { staticClass: "use" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k396"))),
                    ]),
                  ]
                )
              }),
              !_vm.passList.length ? _c("no-data") : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm.tabIndex === 2
      ? _c(
          "div",
          { staticClass: "myprops-content coupon" },
          [
            _c("div", { staticClass: "status-tab" }, [
              _c(
                "div",
                {
                  class: { "status-on": _vm.couponStatus === 0 },
                  on: {
                    click: function ($event) {
                      return _vm.handleCouponStatus(0)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("lang.intimate.valid"))),
                  _vm.couponInfo
                    ? [
                        _vm._v(
                          "(" + _vm._s(_vm.couponInfo.validCount || 0) + ")"
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  class: { "status-on": _vm.couponStatus === 3 },
                  on: {
                    click: function ($event) {
                      return _vm.handleCouponStatus(3)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("lang.intimate.expired"))),
                  _vm.couponInfo
                    ? [
                        _vm._v(
                          "(" + _vm._s(_vm.couponInfo.expireCount || 0) + ")"
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  class: { "status-on": _vm.couponStatus === 2 },
                  on: {
                    click: function ($event) {
                      return _vm.handleCouponStatus(2)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k397"))),
                  _vm.couponInfo
                    ? [
                        _vm._v(
                          "(" + _vm._s(_vm.couponInfo.usedCount || 0) + ")"
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._l(_vm.couponList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "coupon-item",
                  class: { "coupon-off": _vm.couponStatus !== 0 },
                },
                [
                  _c("div", { staticClass: "coupon-con" }, [
                    _vm.couponStatus === 0
                      ? _c("img", {
                          staticClass: "con-top-left",
                          attrs: { src: _vm.getMatchImg("coin") },
                        })
                      : _c("img", {
                          staticClass: "con-top-left",
                          attrs: { src: _vm.getMatchImg("coin-off") },
                        }),
                    _c(
                      "div",
                      { staticClass: "con-top-center" },
                      [
                        _c("div", { staticClass: "conpon-amount" }, [
                          _vm._v(" " + _vm._s(item.amount) + " "),
                          _c("i", [
                            _vm._v(_vm._s(_vm.$t("lang.coupon.extra"))),
                          ]),
                        ]),
                        _c("MyPLabel", {
                          staticClass: "conpon-tip",
                          attrs: {
                            str: item.descV2,
                            customClass: { coin: "coupon-coin-icon" },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.couponStatus === 0
                      ? _c(
                          "div",
                          {
                            staticClass: "con-top-right",
                            on: {
                              click: function ($event) {
                                return _vm.handleCouponUse()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("lang.commonM.k396")))]
                        )
                      : _vm._e(),
                    _vm.couponStatus === 3
                      ? _c("div", { staticClass: "con-top-right" }, [
                          _vm._v(_vm._s(_vm.$t("lang.intimate.expired"))),
                        ])
                      : _vm._e(),
                    _vm.couponStatus === 2
                      ? _c("div", { staticClass: "con-top-right" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k397"))),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "expires" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("lang.commonM.k398")) +
                        ": " +
                        _vm._s(
                          _vm.handleMoment(item.expiredTime, "YYYY-MM-DD")
                        ) +
                        " "
                    ),
                    _c("div", { staticClass: "circle1" }),
                    _c("div", { staticClass: "circle2" }),
                  ]),
                ]
              )
            }),
            !_vm.couponList.length ? _c("no-data") : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm.tabIndex === 3
      ? _c(
          "div",
          { staticClass: "myprops-content frame" },
          [
            _vm._l(_vm.frameList, function (item) {
              return _c("div", { key: item.propId, staticClass: "prop-item" }, [
                _c("div", { staticClass: "item-top" }, [
                  item.remainTimeSeconds > 0
                    ? _c(
                        "div",
                        { staticClass: "item-top-left" },
                        [
                          item.timeType === "forever"
                            ? [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("lang.commonM.k395"))
                                ),
                              ]
                            : _vm._e(),
                          item.timeType === "days"
                            ? [
                                _c("div", { staticClass: "time-icon" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.transformSeconds2(
                                        item.remainTimeSeconds
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            : _vm._e(),
                          item.timeType === "hours"
                            ? [
                                item.countDown && item.countDown.countdownResult
                                  ? [
                                      _c("div", { staticClass: "time-icon" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.countDown.countdownResult.hours
                                          ) +
                                          ":" +
                                          _vm._s(
                                            item.countDown.countdownResult
                                              .minutes
                                          ) +
                                          ":" +
                                          _vm._s(
                                            item.countDown.countdownResult
                                              .seconds
                                          ) +
                                          " "
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _c("div"),
                  _c("div", {
                    staticClass: "detail-icon",
                    on: {
                      click: function ($event) {
                        return _vm.handleFrameRules(item)
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "item-icon" }, [
                  _c("img", { attrs: { src: _vm._f("imgPath")(item.icon) } }),
                ]),
                item.status === "beerExchange"
                  ? _c(
                      "div",
                      {
                        staticClass: "use btn1",
                        on: {
                          click: function ($event) {
                            return _vm.handleFrameItemClick(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.mybeers) +
                            "/" +
                            _vm._s(item.costPropNumber)
                        ),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/packageAssets/common/beer.png"),
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                item.ifValid && item.status === "toTopUp"
                  ? _c(
                      "div",
                      {
                        staticClass: "use btn1",
                        on: {
                          click: function ($event) {
                            return _vm.handleFrameItemClick(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.coupon.desc1")))]
                    )
                  : _vm._e(),
                item.ifValid && item.status === "jumpPath"
                  ? _c(
                      "div",
                      {
                        staticClass: "use btn1",
                        on: {
                          click: function ($event) {
                            return _vm.handleFrameItemClick(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.commonM.k119")))]
                    )
                  : _vm._e(),
                item.ifValid && item.status === "waitEquip"
                  ? _c(
                      "div",
                      {
                        staticClass: "use btn2",
                        on: {
                          click: function ($event) {
                            return _vm.handleFrameItemClick(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.commonM.k399")))]
                    )
                  : _vm._e(),
                item.ifValid && item.status === "beEquiped"
                  ? _c(
                      "div",
                      {
                        staticClass: "use btn2",
                        on: {
                          click: function ($event) {
                            return _vm.handleFrameItemClick(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.commonM.k400")))]
                    )
                  : _vm._e(),
              ])
            }),
            !_vm.frameList.length ? _c("no-data") : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm.passTypeShow
      ? _c("div", { staticClass: "mask" }, [
          _c(
            "div",
            { staticClass: "pass-mask" },
            [
              _vm.passTypeShow === 2
                ? [
                    _c("div", { staticClass: "pass-img" }, [
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("video-pass") },
                      }),
                    ]),
                    _c("div", { staticClass: "pass-txt" }, [
                      _vm._v(_vm._s(_vm.passTypeTxt[_vm.passTypeShow])),
                    ]),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 1.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k401") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 2.  "),
                        _c("MyPLabel", {
                          attrs: {
                            str: _vm.$t("lang.commonM.k402"),
                            numsOption: [
                              {
                                value:
                                  _vm.baseInfo.videoPassServerTimeSeconds || "",
                              },
                            ],
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 3.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k403") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 4.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k404") },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.passTypeShow === 1 || _vm.passTypeShow === 15
                ? [
                    _c("div", { staticClass: "pass-img" }, [
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("super-chat-pass") },
                      }),
                    ]),
                    _c("div", { staticClass: "pass-txt" }, [
                      _vm._v(_vm._s(_vm.passTypeTxt[_vm.passTypeShow])),
                    ]),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 1.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k405") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 2.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k406") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 3.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k407") },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.passTypeShow === 6
                ? [
                    _c("div", { staticClass: "pass-img" }, [
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("call-pass") },
                      }),
                    ]),
                    _c("div", { staticClass: "pass-txt" }, [
                      _vm._v(_vm._s(_vm.passTypeTxt[_vm.passTypeShow])),
                    ]),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 1.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k408") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 2.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k409") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 3.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k410") },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pass-tips" },
                      [
                        _vm._v(" 4.  "),
                        _c("MyPLabel", {
                          attrs: { str: _vm.$t("lang.commonM.k411") },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "pass-mask-btn",
                  on: {
                    click: function ($event) {
                      _vm.passTypeShow = ""
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.ok")))]
              ),
            ],
            2
          ),
          _c("div", { style: { height: `${_vm.bottomBarHeight}px` } }),
        ])
      : _vm._e(),
    _vm.frameTypeShow
      ? _c("div", { staticClass: "mask" }, [
          _c(
            "div",
            { staticClass: "pass-mask" },
            [
              _c("div", { staticClass: "pass-img" }, [
                _c("img", {
                  attrs: { src: _vm._f("imgPath")(_vm.frameTypeShow.icon) },
                }),
              ]),
              _vm._l(_vm.frameTypeTxtArr, function (item, index) {
                return [
                  index === 0
                    ? _c("div", { staticClass: "pass-txt" }, [
                        _vm._v(_vm._s(item)),
                      ])
                    : _c("div", { staticClass: "pass-tips" }, [
                        _vm._v(_vm._s(item)),
                      ]),
                ]
              }),
              _c(
                "div",
                {
                  staticClass: "pass-mask-btn",
                  on: {
                    click: function ($event) {
                      _vm.frameTypeShow = null
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.ok")))]
              ),
            ],
            2
          ),
          _c("div", { style: { height: `${_vm.bottomBarHeight}px` } }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }